const types = {
    REMOTE_ORAL_EXAM_SET_CANDIDATE_JOINED: 'REMOTE_ORAL_EXAM_SET_CANDIDATE_JOINED',
    REMOTE_ORAL_EXAM_SET_CONTEXT_DISPLAY_STATUS_ACKNOWLEDGE_SENT: 'REMOTE_ORAL_EXAM_SET_CONTEXT_DISPLAY_STATUS_ACKNOWLEDGE_SENT',
    REMOTE_ORAL_EXAM_SET_SESSION_COMPLETED: 'REMOTE_ORAL_EXAM_SET_SESSION_COMPLETED',
    REMOTE_ORAL_EXAM_SET_SESSION_INFO: 'REMOTE_ORAL_EXAM_SET_SESSION_INFO',
    REMOTE_ORAL_EXAM_SET_WAITING_ROOM_STATUS: 'REMOTE_ORAL_EXAM_SET_WAITING_ROOM_STATUS',
    REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_DETAIL: 'REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_DETAIL',
    REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_STATUS: 'REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_STATUS',
};

const remoteOralExamActions = {
    types,

    setSessionInfo(sessionInfo) {
        return { type: types.REMOTE_ORAL_EXAM_SET_SESSION_INFO, sessionInfo };
    },

    setWaitingRoomStatus(data) {
        return { type: types.REMOTE_ORAL_EXAM_SET_WAITING_ROOM_STATUS, data };
    },

    setCandidateJoined(isJoined) {
        return { type: types.REMOTE_ORAL_EXAM_SET_CANDIDATE_JOINED, isJoined };
    },

    setSessionCompleted(isCompleted) {
        return { type: types.REMOTE_ORAL_EXAM_SET_SESSION_COMPLETED, isCompleted };
    },

    setZoomTestCallDetail(detail) {
        return { type: types.REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_DETAIL, detail };
    },

    setTestZoomCallStatus(status) {
        return { type: types.REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_STATUS, status };
    },

    setContextDisplayStatusAcknowledgeSent(isSent) {
        return { type: types.REMOTE_ORAL_EXAM_SET_CONTEXT_DISPLAY_STATUS_ACKNOWLEDGE_SENT, isSent };
    },
};

export default remoteOralExamActions;
